export function formatDate(date: Date | string) {
    if (typeof date === 'string') {
        date = new Date(date);
    }
    return new Intl.DateTimeFormat(navigator.language, { month: 'short', day: '2-digit' })
        .format(date)
        .toUpperCase();
}
